// Beverage tree: move native inputs, never duplicate or invent filter values.
const BeverageFilterTree = {
  fields: ['filter.p.m.custom.tipo_de_bebida', 'filter.p.m.custom.classificacao_da_bebida', 'filter.p.m.custom.categoria_da_bebida'],
  optionSettings: {
    //'filter.p.m.custom.tipo_de_bebida': {
    //  order: ['Vinhos', 'Espirituosas']
    //},
    'filter.p.m.custom.classificacao_da_bebida': {
      labels: { 'Tinto': 'Vinho Tinto', 'Branco': 'Vinho Branco', 'Rosé': 'Vinho Rosé' },
      order: ['Vinho Tinto', 'Vinho Branco', 'Vinho Rosé'],
    }
  },
  normalize(value) { return String(value || '').split('/').pop(); },
  optionLabel(item) {
    return item?.querySelector('.text-size--small')?.textContent.replace(/\s*\(\d+\)\s*$/, '').trim() || '';
  },
     // The tree reuses Shopify inputs, then changes their visible labels.
  configureOptionLabels(form) {
    form.querySelectorAll('input[type="checkbox"]').forEach(input => {
      const settings = this.optionSettings[input.name];
      const item = input.closest('li');
      const label = this.optionLabel(item);
      const text = item?.querySelector('.text-size--small');
      const replacement = settings?.labels?.[label];
      if (text && replacement) text.textContent = text.textContent.replace(label, replacement);
    });
  },
    // The tree reuses Shopify inputs, then changes their sibling order.
  configureOptionOrder(form) {
    form.querySelectorAll('.facets__list, .beverage-filter-facet__children').forEach(list => {
      const items = Array.from(list.children).filter(item => item.matches('li'));
      const field = items[0]?.querySelector('input[type="checkbox"]')?.name;
      const order = this.optionSettings[field]?.order;
      if (!order) return;
      items.sort((first, second) => {
        const firstIndex = order.indexOf(this.optionLabel(first));
        const secondIndex = order.indexOf(this.optionLabel(second));
        return (firstIndex < 0 ? order.length : firstIndex) - (secondIndex < 0 ? order.length : secondIndex);
      }).forEach(item => list.append(item));
    });
  },
  // Shopify renders selected-filter chips outside the tree, so apply the same display labels here.
  configureActiveFacets() {
    document.querySelectorAll('[data-filter-param].active-facets__button').forEach(chip => {
      const labels = this.optionSettings[chip.dataset.filterParam]?.labels;
      const textNode = Array.from(chip.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
      const label = textNode?.textContent.trim();
      const replacement = labels?.[label];
      if (textNode && replacement) textNode.textContent = textNode.textContent.replace(label, replacement);
    });
  },
  configureOptions(form) {
    this.configureOptionLabels(form);
    this.configureOptionOrder(form);
    this.configureActiveFacets();
  },
  buildAll() {
    document.querySelectorAll('facet-filters-form form').forEach(form => this.build(form));
  },
  // AJAX replaces active-filter chips after selection, so reapply configured labels to the new markup.
  watchActiveFacets() {
    const observer = new MutationObserver(mutations => {
      const activeFacetsChanged = mutations.some(mutation =>
        mutation.target.closest?.('.active-facets') ||
        Array.from(mutation.addedNodes).some(node => node.nodeType === Node.ELEMENT_NODE && node.matches?.('.active-facets, .active-facets *'))
      );
      if (activeFacetsChanged) this.configureActiveFacets();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  },
  build(form) {
    const prefix = window.KT_PREFIX || '';
    const mapElement = form.querySelector('[data-beverage-filter-map]');
    if (!mapElement || mapElement.dataset.built === 'true') return;
    let relations;
    try { relations = JSON.parse(mapElement.textContent); } catch (_) { return; }
    if (!relations.complete) return;
    const groups = this.fields.map(name => {
      const inputs = Array.from(form.querySelectorAll('input[type="checkbox"]')).filter(input => input.name === name);
      const panel = inputs[0]?.closest(`.${prefix}js-filter`);
      const items = new Map(inputs.map(input => [this.normalize(input.value), input.closest('li')]));
      return { name, panel, items };
    });
    if (!groups[0].panel) return;
    const attach = (parent, child) => {
      if (!parent || !child) return;
      let children = Array.from(parent.children).find(element => element.classList.contains('beverage-filter-facet__children'));
      if (!children) {
        children = document.createElement('ul');
        children.setAttribute('role', 'list');
        children.className = `${prefix}list-unstyled beverage-filter-facet__children`;
        parent.append(children);
      }
      children.append(child);
    };
    relations.classifications.forEach(relation => {
      attach(groups[0].items.get(this.normalize(relation.parent)), groups[1].items.get(this.normalize(relation.id)));
    });
    relations.categories.forEach(relation => {
      attach(groups[1].items.get(this.normalize(relation.parent)), groups[2].items.get(this.normalize(relation.id)));
    });
    this.configureOptions(form);
    // Keep unmatched entries in their original panels. Empty panels stay in the
    // DOM so the theme can update them from the next server response.
    groups.slice(1).forEach(group => {
      if (!group.panel) return;
      const empty = !Array.from(group.panel.querySelectorAll('input[type="checkbox"]')).some(input => input.name === group.name);
      group.panel.hidden = empty;
      // Theme display rules can override the browser's default [hidden] style.
      // Explicitly hide empty panels, while keeping them available for AJAX updates.
      if (empty) {
        group.panel.style.setProperty('display', 'none', 'important');
      } else {
        group.panel.style.removeProperty('display');
      }
    });
    // Selecting a node replaces the whole tree selection, so every node stays reachable
    // even when Shopify reports zero results for the current combination.
    groups.forEach(group => {
      group.items.forEach(item => {
        const input = item?.querySelector('input[type="checkbox"]');
        if (input) input.disabled = false;
        item?.querySelector('label')?.classList.remove(`${prefix}facet-checkbox--disabled`);
      });
    });
    const reset = groups[0].panel.querySelector(`.${prefix}facets__reset`);
    if (reset) {
      const url = new URL(reset.href, window.location.origin);
      this.fields.forEach(field => url.searchParams.delete(field));
      reset.href = url.pathname + url.search;
    }
    this.bindSingleSelect(form);
    mapElement.dataset.built = 'true';
  },
  // The tree behaves as one radio group: picking a node replaces the whole tree selection,
  // so the three levels are never ANDed into an impossible combination.
  bindSingleSelect(form) {
    if (form.dataset.beverageSingleSelect === 'true') return;
    form.dataset.beverageSingleSelect = 'true';
    // Capture phase runs before the form's debounced submit handler, so FormData sees the corrected state.
    form.addEventListener('input', (event) => {
      const input = event.target;
      if (!input.checked || !this.fields.includes(input.name)) return;
      if (!form.querySelector('[data-beverage-filter-map][data-built="true"]')) return;
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(other => {
        if (other !== input && this.fields.includes(other.name)) other.checked = false;
      });
    }, true);
  }
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    BeverageFilterTree.buildAll();
    BeverageFilterTree.watchActiveFacets();
  }, { once: true });
} else {
  BeverageFilterTree.buildAll();
  BeverageFilterTree.watchActiveFacets();
}
document.addEventListener('facets:active-facets-rendered', () => BeverageFilterTree.configureActiveFacets());
document.addEventListener('shopify:section:load', () => BeverageFilterTree.buildAll());
